import { getDataOverviewList } from "@/services/data_overview/data_overview";
import { dataOverviewListMapper } from "@/domain/data_overview/mapper";
import { EMPTY_DATA_OVERVIEW_LIST } from "@/domain/data_overview/data";

const state = {
  dataOverviewList: EMPTY_DATA_OVERVIEW_LIST,
};

const mutations = {
  SET_DATA_OVERVIEW_LIST(state, payload) {
    state.dataOverviewList = payload;
  },
};

const getters = {
  getDataOverviewList: (state) => state.dataOverviewList,
};

const actions = {
  async fetchDataOverviewList({ commit }) {
    try {
      const response = await getDataOverviewList();
      const mappedData = dataOverviewListMapper(response);

      commit("SET_DATA_OVERVIEW_LIST", mappedData);
    } catch (error) {

      commit("SET_DATA_OVERVIEW_LIST", EMPTY_DATA_OVERVIEW_LIST);
    }
  },
};

export default {
  namespaced: false,
  state,
  mutations,
  getters,
  actions,
};
